import { render, staticRenderFns } from "./SubLocationForm.vue?vue&type=template&id=5402d750&scoped=true&"
import script from "./SubLocationForm.vue?vue&type=script&lang=js&"
export * from "./SubLocationForm.vue?vue&type=script&lang=js&"
import style0 from "./SubLocationForm.vue?vue&type=style&index=0&id=5402d750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5402d750",
  null
  
)

export default component.exports